export const formatCoinFlipCoin = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";
  return num.toLocaleString();
};

export const sideLabel = (side) => {
  if (side === "head") return "Head";
  if (side === "tail") return "Tail";
  return side || "—";
};

export function hasCoinFlipOutcome(round) {
  return round?.outcome === "head" || round?.outcome === "tail";
}

export function resolveBondCoinFlipSettledRound({
  revealedRound = null,
  lastSettled = null,
  ticketRound = null,
} = {}) {
  const ticketId = String(ticketRound?._id || ticketRound?.id || "");
  for (const candidate of [revealedRound, lastSettled]) {
    if (!hasCoinFlipOutcome(candidate)) continue;
    const candidateId = String(candidate._id || candidate?.id || "");
    if (!ticketId || !candidateId || candidateId === ticketId) return candidate;
  }
  return null;
}

/** Instant gross payout quote — mirrors backend buildFlipQuote. */
export const computeCoinFlipQuote = (stake, constants) => {
  const resolvedStake = Math.floor(Number(stake) || 0);
  if (resolvedStake <= 0) return null;

  const odds = Number(constants?.odds) || 2;
  if (!Number.isFinite(odds) || odds <= 1) return null;

  const grossPayout = Math.floor(resolvedStake * odds);
  const reserve = Math.max(0, grossPayout - resolvedStake);

  return {
    stake: resolvedStake,
    odds,
    grossPayout,
    reserve,
    maxWin: grossPayout,
  };
};
